import Component from '@glimmer/component';

export default class WizardStepComponent extends Component {
  <template>
    <div class="c-wizard-step__description" ...attributes>{{yield}}</div>
  </template>
}
